import React from 'react';
import * as serializer from 'basic-editor-value-serializer';
import BaseElement from '../base';
import IconSVG from './svg';
import nodeControls from '../../node-menu/control-types';

function Icon(props) {
  return <BaseElement {...props} className="icon-block" contentEditable={false}
    customNodeControls={[nodeControls.ALIGNMENT, nodeControls.TEXT_COLOR, nodeControls.ICON_SETTINGS]}>
    <div {...props.attributes} contentEditable={false}>
      <IconSVG settings={serializer.utilities.node.icon.readSettings(props.element)} />
      {props.children}
    </div>
  </BaseElement>;
}

export default Icon;
